import React, { FC, useState } from "react";
import { Height } from "../../../../../../types/baseType";
import { EfficiencySliceState } from "../../../../../../store/reducers/dashboard/works/efficiency";
import { useTypedSelector } from "../../../../../../hooks/useTypedSelector";
import st from './styles.module.scss';
import FlexLine from "../../../../../../components/elements/flexLine/FlexLine";
import Container from "../../../../../../components/elements/container/Container";
import * as Highcharts from "highcharts";
import EfficiencyChartLegend from "./components/EfficiencyChartLegend/EfficiencyChartLegend";
import EfficiencyCircleChart from "./components/EfficiencyCircleChart/EfficiencyCircleChart";
import { useEfficiencyElements } from "../hooks/useEfficiencyElements";
import stBase from '../stylesBase.module.scss';
import { WorkDisplayPeriod } from "../../../../../../types/service/dashboard/IWorksDashboardService";

type EfficiencyChartProps = {
    period: WorkDisplayPeriod
}

export type EfficiencyElement = {
    id: string
    color: string
    name: string
    duration: number
}

const EfficiencyChart: FC<EfficiencyChartProps> = ({ period  }) => {
    const {
        data
    } = useTypedSelector<EfficiencySliceState>(state => state.efficiencyDetalization)

    const [chartApi, setChartApi] = useState<Highcharts.Chart>()

    const elements: EfficiencyElement[] = useEfficiencyElements(period, data)

    return (
        <Container className={st['chart']}>
            <FlexLine style={{marginBottom: 24}}>
                <span className={stBase['chart__title']}>Эффективность</span>
            </FlexLine>
            <Container height={Height.Full} className={st['chart__content']} >
                <EfficiencyCircleChart chartCallback={setChartApi} elements={elements} />
                <EfficiencyChartLegend chartApi={chartApi} elements={elements} />
            </Container>
        </Container>
    )
}

export default EfficiencyChart;